import { Component, Input, OnInit, EventEmitter, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, UntypedFormGroup } from '@angular/forms';
import { InputModes } from './input-modes-types';

@Component({
  selector: 'vm-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true,
    },
  ],
})
export class TextInputComponent implements OnInit, ControlValueAccessor {
  @Input() public autofocus = false;

  @Input() public autocomplete?: string;

  @Input() public idMultiline: string;

  @Input() public name: string;

  @Input() public disabled = false;

  @Input() public label: string = null;

  @Input() public placeholder: string = null;

  @Input() public multiLine = false;

  @Input() public isError = false;

  @Input() public errorMessage: string = null;

  @Input() public maxLength = 2000;

  @Input() public group: UntypedFormGroup;

  @Input() public type = 'text';

  @Input() public prefix = '';

  @Input() public suffix = '';

  @Input() public iconColor = '';

  @Input() public iconStyle = '';

  @Input() public passwordShowOption = false;

  @Input() public showLabel = true;

  @Input() public updateOption: 'change' | 'blur' | 'submit';
  updateOptionObject;

  @Input() public inputMode: InputModes = InputModes.Text;

  @Input() public ignoreTrim = false;

  @Input() public showCharacterCount = false;

  // eslint-disable-next-line
  @Output() public change: EventEmitter<number> = new EventEmitter();

  @Output() public iconClick = new EventEmitter();

  @Output() public blurValue = new EventEmitter();

  @Input()
  public set value(v: number) {
    this.writeValue(v);
    this.notify();
  }

  public get value(): number {
    return this.inputValue;
  }

  private inputValue = null;

  private onChange: (v) => { [key: string]: any };
  private onTouched: () => { [key: string]: any };

  constructor() {}

  public isEmpty = true;

  public ngOnInit(): void {
    this.updateOptionObject = { updateOn: this.updateOption };
    this.passwordShowOption = this.passwordShowOption && this.type === 'password';
  }

  public writeValue(value: number): void {
    this.inputValue = value;
    if (this.inputValue && !this.ignoreTrim) {
      this.inputValue = this.inputValue.toString().trim();
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public onBlur(value) {
    this.blurValue.emit(value);
  }

  public setDisabledState?(disabled: boolean): void {
    this.disabled = disabled;
  }

  private notify(): void {
    this.isEmpty = this.isFieldEmpty(this.value);
    if (this.onChange) {
      this.onChange(this.value);
    }
    if (this.onTouched) {
      this.onTouched();
    }
  }

  private isFieldEmpty(text: any): boolean {
    return !text || text.length === 0;
  }

  onIconClick($event): void {
    this.iconClick.emit($event);
  }

  togglePasswordVisibility(): void {
    if (this.passwordShowOption) {
      this.type = this.type === 'text' ? 'password' : 'text';
    }
  }

  isPasswordVisible(): boolean {
    return this.passwordShowOption && this.type === 'text';
  }
}
